// extracted by mini-css-extract-plugin
export default {"wrapper":"YIWIXtvgRZiUQHvwO7fT"};